/**
 * Product PDP: add_to_cart + begin_checkout via GT-T5P4FHD.
 * Covers buy-options CTA, sticky cart, ILCartEvents slide-out drawer, and cart:updated.
 */
(function () {
  'use strict';

  /* view_item/page_view stay on GT-T5P4FHD (ild-view-item-remarketing.js).
     ATC/checkout: GA4 ecommerce event + labeled Ads conversion (Shopping App actions).
     Tag Assistant "Add to Cart" to AW-870900097 alone does NOT increment the Primary
     conversion — Google Ads API requires send_to with action label (verified 2026-06-19). */
  var GA4_ID = 'G-XE6CZ5DL31';
  var AW_ATC_CONVERSION = 'AW-870900097/zGb0COu467wcEIHDo58D';
  var AW_CHECKOUT_CONVERSION = 'AW-870900097/lAM0COi467wcEIHDo58D';

  function priceToDec(cents) {
    return parseFloat(((cents || 0) / 100).toFixed(2));
  }

  function activeVariantId() {
    var card = document.querySelector('.buy-option-card.active');
    return card && card.dataset.variantId ? String(card.dataset.variantId) : '';
  }

  function ecomContext(variantId) {
    var ecom = window.__ILD_ECOM_VIEW || {};
    var box = document.querySelector('.buy-options-section[data-product-id]');
    var card = document.querySelector('.buy-option-card.active');
    return {
      product_id: ecom.item_id || (box && box.dataset.productId) || '',
      item_name: ecom.item_name || (box && box.dataset.productTitle) || '',
      currency:
        ecom.currency ||
        (box && box.dataset.currency) ||
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
        'USD',
      value: ecom.value || 0,
      variant_id: variantId || ecom.item_variant_id || (card && card.dataset.variantId) || '',
      price_cents: card && card.dataset.priceCents,
    };
  }

  function lineFromPayload(payload, variantId) {
    if (!payload) return null;
    if (payload.items && payload.items.length) {
      if (variantId) {
        var match = payload.items.find(function (i) {
          return String(i.variant_id || i.id) === String(variantId);
        });
        if (match) return match;
      }
      return payload.items[payload.items.length - 1];
    }
    if (payload.product_id || payload.variant_id || payload.id) return payload;
    return null;
  }

  function itemFromEcomView(variantId, quantity) {
    var ecom = window.__ILD_ECOM_VIEW || {};
    var ctx = ecomContext(variantId);
    var itemId = ecom.item_id || ctx.product_id;
    if (!itemId) return null;
    var card = document.querySelector('.buy-option-card.active');
    var priceCents = card && card.dataset.priceCents;
    var price = priceCents ? priceToDec(parseInt(priceCents, 10)) : parseFloat(ecom.value);
    if (isNaN(price)) price = 0;
    var qty = quantity || 1;
    var id = String(itemId);
    return {
      item_id: id,
      id: id,
      item_name: ecom.item_name || ctx.item_name || '',
      item_variant: (card && card.dataset.optionLabel) || '',
      price: price,
      quantity: qty,
      google_business_vertical: 'retail',
    };
  }

  function itemFromLine(line, ctx) {
    ctx = ctx || {};
    var itemId = line && (line.product_id || line.productId);
    if (!itemId && line && line.id && !line.items) {
      itemId = ctx.product_id || line.product_id;
    }
    if (!itemId && ctx.product_id) itemId = ctx.product_id;
    if (!itemId) return null;
    var priceCents = line && (line.final_price || line.price || line.line_price);
    if (!priceCents && ctx.price_cents) priceCents = parseInt(ctx.price_cents, 10);
    if (!priceCents && ctx.value) priceCents = Math.round(parseFloat(ctx.value) * 100);
    var id = String(itemId);
    return {
      item_id: id,
      id: id,
      item_name: (line && (line.product_title || line.title || line.name)) || ctx.item_name || '',
      item_variant: (line && line.variant_title) || '',
      price: priceToDec(priceCents || 0),
      quantity: (line && line.quantity) || 1,
      google_business_vertical: 'retail',
    };
  }

  function markAtcFired(payload) {
    if (!payload || typeof payload !== 'object') return;
    payload.__ildGtagAtcFired = true;
    payload._gtagFired = true;
  }

  function alreadyFired(payload) {
    return payload && (payload.__ildGtagAtcFired || payload._gtagFired);
  }

  function safeGtagAddToCart(currency, value, items) {
    if (typeof gtag !== 'function') return false;
    gtag('event', 'add_to_cart', {
      send_to: GA4_ID,
      currency: currency,
      value: value,
      items: items,
    });
    gtag('event', 'conversion', {
      send_to: AW_ATC_CONVERSION,
      currency: currency,
      value: value,
    });
    return true;
  }

  function emitAddToCart(line, ctx, payload) {
    var item = itemFromLine(line, ctx);
    if (!item || !item.item_id) return false;
    var currency = ctx.currency || 'USD';
    var value = item.price * (item.quantity || 1);
    if (line) {
      var lineVal = priceToDec(
        line.final_line_price || line.final_price || line.line_price || line.price || 0
      );
      if (lineVal) value = lineVal;
    }
    if (!value && ctx.value) value = parseFloat(ctx.value);
    if (safeGtagAddToCart(currency, value, [item])) {
      if (payload) markAtcFired(payload);
      return true;
    }
    return false;
  }

  function fireFromCartJs(variantId, ctx, payload) {
    return fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var items = cart.items || [];
        var line = null;
        if (variantId) {
          line = items.find(function (i) {
            return String(i.variant_id) === String(variantId);
          });
        }
        if (!line && items.length) line = items[items.length - 1];
        if (!line) return false;
        ctx.currency = cart.currency || ctx.currency;
        return emitAddToCart(line, ctx, payload);
      })
      .catch(function () {
        return false;
      });
  }

  function fireAddToCartFromEcomView(variantId, payload) {
    if (alreadyFired(payload)) return false;
    variantId = variantId || activeVariantId();
    var item = itemFromEcomView(variantId, 1);
    if (!item) return false;
    var currency =
      (window.__ILD_ECOM_VIEW && window.__ILD_ECOM_VIEW.currency) ||
      ecomContext(variantId).currency ||
      'USD';
    var value = item.price * item.quantity;
    if (safeGtagAddToCart(currency, value, [item])) {
      if (payload) markAtcFired(payload);
      return true;
    }
    return false;
  }

  function fireAddToCartFromPayload(payload, variantId) {
    if (alreadyFired(payload)) return;
    variantId = variantId || activeVariantId();
    var ctx = ecomContext(variantId);
    // Prefer the real /cart/add response (line): it has the actual
    // variant/price/quantity Shopify just charged. ecomView is the page-load
    // default and is only a fallback for UIs whose payload doesn't carry a
    // usable line - it was tried first before, which silently reported the
    // wrong item/price/variant on any UI without a .buy-option-card.active
    // (e.g. the il-qb quick-buy tiers in the chrome-PDP buy modal - confirmed
    // live on DeepSleep Formula's 4-Bottle tier, 2026-08-15).
    var line = lineFromPayload(payload, variantId);
    if (line && emitAddToCart(line, ctx, payload)) return;
    if (fireAddToCartFromEcomView(variantId, payload)) return;
    fireFromCartJs(variantId, ctx, payload);
  }

  window.addEventListener('cart:updated', function (evt) {
    fireAddToCartFromPayload(evt && evt.detail, activeVariantId());
    refreshCartSnapshot();
  });

  function bindPubSub() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (detail) {
      if (!detail || !detail.cartData) return;
      fireAddToCartFromPayload(detail.cartData, detail.productVariantId);
      refreshCartSnapshot();
    });
  }

  function wrapILCartEvents() {
    if (!window.ILCartEvents || window.ILCartEvents.__ildGtagWrapped) return;
    var orig = window.ILCartEvents.addToCartWithTracking;
    if (typeof orig !== 'function') return;
    window.ILCartEvents.__ildGtagWrapped = true;
    window.ILCartEvents.addToCartWithTracking = function (opts) {
      return orig.call(window.ILCartEvents, opts).then(function (data) {
        fireAddToCartFromPayload(data, opts && opts.variantId);
        return data;
      });
    };
  }

  function installHooks() {
    wrapILCartEvents();
    bindPubSub();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installHooks, { once: true });
  } else {
    installHooks();
  }

  var pollAttempts = 0;
  var pollTimer = setInterval(function () {
    pollAttempts += 1;
    wrapILCartEvents();
    if ((window.ILCartEvents && window.ILCartEvents.__ildGtagWrapped) || pollAttempts >= 24) {
      clearInterval(pollTimer);
    }
  }, 250);

  // Last-known cart snapshot, kept fresh by cart:updated/pubsub so
  // fireBeginCheckout() can fire synchronously at click time instead of
  // racing an async /cart.js fetch against navigation to /checkout - a
  // race that, if lost, silently and permanently dropped the event for
  // that session (the dedup flag below is set before the fetch resolves).
  var lastCartSnapshot = null;

  function snapshotFromCart(cart) {
    // Only trust genuine full-cart payloads (/cart.js, /cart/change.js,
    // /cart/update.js all include total_price at the cart level).
    // cart:updated's detail is an /cart/add.js response - a single line
    // item or {items:[]} with no cart-level total - and must NOT be used
    // here, or begin_checkout would report the wrong (near-zero) value.
    if (!cart || typeof cart.total_price !== 'number') return null;
    var currency = cart.currency || 'USD';
    var value = priceToDec(cart.total_price);
    var items = (cart.items || [])
      .map(function (line) {
        return itemFromLine(line, ecomContext());
      })
      .filter(Boolean);
    return { currency: currency, value: value, items: items };
  }

  function cacheCartSnapshot(cart) {
    var snap = snapshotFromCart(cart);
    if (snap) lastCartSnapshot = snap;
  }

  // Fire-and-forget refresh, kicked off whenever the cart changes (not at
  // checkout-click time) so a genuine full-cart snapshot is very likely
  // already cached by the time the user actually clicks checkout.
  function refreshCartSnapshot() {
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(cacheCartSnapshot)
      .catch(function () {});
  }

  function sendBeginCheckout(snap) {
    gtag('event', 'begin_checkout', {
      send_to: GA4_ID,
      currency: snap.currency,
      value: snap.value,
      items: snap.items,
      transport_type: 'beacon',
    });
    gtag('event', 'conversion', {
      send_to: AW_CHECKOUT_CONVERSION,
      currency: snap.currency,
      value: snap.value,
      transport_type: 'beacon',
    });
  }

  function fireBeginCheckout() {
    if (typeof gtag !== 'function') return;
    try {
      if (sessionStorage.getItem('ild_begin_checkout_fired')) return;
      sessionStorage.setItem('ild_begin_checkout_fired', '1');
    } catch (e) {}
    if (lastCartSnapshot) {
      sendBeginCheckout(lastCartSnapshot);
      return;
    }
    // No cached snapshot yet (first cart interaction of the session) -
    // fall back to fetching it; keepalive lets the request complete even
    // if the page has already started navigating away.
    fetch('/cart.js', { keepalive: true })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var snap = snapshotFromCart(cart);
        if (snap) sendBeginCheckout(snap);
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (evt) {
    var t = evt && evt.target;
    if (!t) return;
    if (t.id === 'CartDrawer-Checkout' || (t.closest && t.closest('#CartDrawer-Checkout'))) {
      fireBeginCheckout();
      return;
    }
    if (t.name === 'checkout' || (t.closest && t.closest('[name="checkout"]'))) {
      fireBeginCheckout();
      return;
    }
    var anchor = t.closest && t.closest('a[href*="/checkout"]');
    if (anchor) fireBeginCheckout();
  });
})();
